import React, { useEffect, useState } from "react"
import { ChevronUp } from "lucide-react"

/**
 * @param {{ showAfterPx?: number, className?: string }} props
 */
export default function ScrollToTopButton({
    showAfterPx = 320,
    className = "",
}) {
    const [isVisible, setIsVisible] = useState(false)

    useEffect(() => {
        function onScroll() {
            setIsVisible(window.scrollY >= showAfterPx)
        }
        onScroll()
        window.addEventListener("scroll", onScroll, { passive: true })
        return () => window.removeEventListener("scroll", onScroll)
    }, [showAfterPx])

    if (!isVisible) {
        return null
    }

    return (
        <button
            type="button"
            aria-label="Scroll to top"
            className={`btn btn-dark rounded-circle shadow ${className}`}
            style={{
                position: "fixed",
                right: "16px",
                bottom: "16px",
                width: "44px",
                height: "44px",
                zIndex: 1080,
                lineHeight: 1,
            }}
            onClick={() => window.scrollTo({ top: 0, behavior: "smooth" })}
        >
            <ChevronUp size={18} />
        </button>
    )
}
